
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.48.935a.487.487 0 00-.529.105L.142 5.604a.485.485 0 000 .686l5.81 4.542a.482.482 0 00.529.106.477.477 0 00.29-.449V7.77c6.212 0 8.929 1.752 8.515 7.333 2.632-8.929-2.42-10.947-8.515-10.947V1.383a.476.476 0 00-.29-.448z"}})])
          )
        }
      }
    